module.exports = __webpack_public_path__ + "static/media/emoji2.ca3022e9.svg";